import useAsyncData from "../../../../hooks/use-async-data";
import orderOptimizerService from "../../order-optimizer.service";
import OrderOptimizerDetailsOther from "./order-optimizer-details-other";
import OrderOptimizerDetailsOtherParams from "./order-optimizer-details-other-params";

const useOrderOptimizerDetailsOther = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<OrderOptimizerDetailsOther | null>(null);

  const load = async (
    params: OrderOptimizerDetailsOtherParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const orderOptimizerDetailsOther: OrderOptimizerDetailsOther =
        await orderOptimizerService.getOtherDetails(params, signal);

      setData(orderOptimizerDetailsOther);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setIsError(false);
    setIsLoading(true);
    setData(null);
  };

  return {
    data,
    isError,
    isLoading,
    load,
    reset,
  };
};

export default useOrderOptimizerDetailsOther;
